export enum ClientAnalyticsEventType {
  MESSSAGE_SENT_FROM_EXPERIENCE_PAGE = 'message_sent_from_experience_page',
  MESSSAGE_SENT_FROM_CHAT = 'message_sent_from_chat',
  MESSSAGE_SENT_FROM_HOST_PROFILE = 'message_sent_from_host_profile',
  MESSSAGE_SENT_FROM_BOOKINGS_PAGE = 'message_sent_from_bookings_page',
  MESSAGE_FLAGGED_IN_CHAT = 'message_flagged_in_chat',
  MESSAGE_WITH_PICTURES = 'message_with_pictures',
  SKIP_BOOK_MEETING_WITH_CURATOR = 'skipped_booking_meeting_with_curator',
  STARTED_INSPIRATION = 'started_inspiration',
  VIEWED_BUILDER_STEP = 'viewed_builder_step',
  VIEWED_INSPIRATION_STEP = 'viewed_inspiration_step',
  STARTED_EXPERIENCE_BUILDER = 'started_experience_builder',
  SUBMITTED_EXPERIENCE_FOR_REVIEW = 'submitted_experience_for_review',
  CLICKED_JOIN_EVENT = 'clicked_join_event',
  JOIN_EXPERIENCE_NOT_LOGGED_IN = 'join_experience_not_logged_in',
  SUBMIT_EXPERIENCE_REQUEST = 'submit_experience_request',
  CLBC_PROMPT_RESPONSE = 'clbc_prompt_response',
  VIEWED_EXPERIENCE = 'viewed_experience',
}
